import { Box } from "@material-ui/core";
import { EnvironmentalImpact } from "./EnvironmentalImpact";
import { SolarReport } from "../../../../api/Quote/SolarReport";

export const EnvironmentalImpactSection = ({
  solarReportData,
  isGraphVisible
}: {
  solarReportData: SolarReport | null;
  isGraphVisible?: boolean;
}) => {
  if (!isGraphVisible) return null;
  return (
    <Box mt={"97px"}>
      <EnvironmentalImpact solarReportData={solarReportData} />
    </Box>
  );
};
